import { BrowserRouter } from 'react-router-dom';

import { GlobalStyle } from 'styles/global-styles';
import { setBrandIconAndStoredValue } from 'utils/brands';

import Router from './Router';
import { useEffect } from 'react';
import Auth from 'app/api/Auth';
import { BrandName } from 'utils/types';

export function App() {

    useEffect(() => {
        let brand: BrandName | null = Auth.getCurrentBrandName();
        if(!brand) brand = BrandName.bzi;
        setBrandIconAndStoredValue(brand);

      }, []);
    
    return (
        <BrowserRouter>
            <Router />
            <GlobalStyle />
        </BrowserRouter>
    );
}
